import { MoonIcon, SunIcon } from '@chakra-ui/icons';
import { IconButton, useColorMode, useColorModeValue } from '@chakra-ui/react';
import { jsx as _jsx } from "react/jsx-runtime";
export default function ColorModeSwitcher() {
  var _useColorMode = useColorMode(),
    toggleColorMode = _useColorMode.toggleColorMode;
  var text = useColorModeValue('dark', 'light');
  var SwitchIcon = useColorModeValue(MoonIcon, SunIcon);
  return _jsx(IconButton, {
    "aria-label": "Switch to ".concat(text, " mode"),
    size: "md",
    fontSize: "lg",
    variant: "ghost",
    color: "current",
    marginLeft: "2",
    onClick: toggleColorMode,
    icon: _jsx(SwitchIcon, {})
  });
}